const shortcodeName = 'shortcode';
const shortcodeRemoveName = 'shortcoderemove';
const shortcodeEditName = 'shortcodeedit';

let currentEditElement: HTMLDivElement | null = null;

const ShortCodeInit = (tinymce: any): any =>
{
    tinymce.PluginManager.add(shortcodeName, function(editor: any)
    {
        const style = `div[data-shortcode] {
            background: #ffebcd;
            color: #805500;
            font-size: 15px;
            letter-spacing: 1px;
            text-transform: uppercase;
            padding: 24px;
            border-radius: 10px;
            cursor: pointer;
            min-height: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            margin: 16px 0;
            background-image: url(/static/img/code-line.svg);
            background-repeat: repeat;
            background-size: 34px;
            background-position: 0 2px;
            border: 2px solid transparent;
            position: relative;
        }
        div[data-shortcode].mceNonEditable {
            outline: none !important;
            cursor: pointer !important;
        }
        div[data-shortcode]:focus,
        div[data-shortcode]:active {
            border-color: #805500;
        }
        div[data-shortcode]::selection {
            background: transparent;
        }`;

        editor.contentStyles.push(style);

        editor.ui.registry.addIcon('rectangleCode', `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 22 22"><path fill="currentColor" transform="translate(3,3)" d="M0 1.75C0 .784.784 0 1.75 0h12.5C15.216 0 16 .784 16 1.75v12.5A1.75 1.75 0 0 1 14.25 16H1.75A1.75 1.75 0 0 1 0 14.25Zm1.75-.25a.25.25 0 0 0-.25.25v12.5c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25Zm7.47 3.97a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.749.749 0 0 1-1.275-.326a.75.75 0 0 1 .215-.734L10.69 8L9.22 6.53a.75.75 0 0 1 0-1.06M6.78 6.53L5.31 8l1.47 1.47a.749.749 0 0 1-.326 1.275a.75.75 0 0 1-.734-.215l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 0 1 1.042.018a.75.75 0 0 1 .018 1.042"/></svg>`);

        editor.ui.registry.addButton(shortcodeName, {
            icon: 'rectangleCode',
            tooltip: $t('[[[Dodaj shortcode]]]'),
            onAction: function()
            {
                closeAllMenus(editor);

                currentEditElement = null;
                editor.execCommand('openShortCodesModal');
            }
        });

        editor.ui.registry.addButton(shortcodeRemoveName, {
            icon: 'remove',
            tooltip: $t('[[[Usuń shortcode]]]'),
            onAction: () =>
            {
                const el = editor.selection.getNode() as HTMLDivElement;
                const id = el.getAttribute('data-shortcode');

                if (id)
                {
                    ShortCodeRemove(editor, parseInt(id, 10));
                }

                closeAllMenus(editor);
            },
        });

        editor.ui.registry.addButton(shortcodeEditName, {
            icon: 'edit-block',
            tooltip: $t('[[[Edytuj shortcode]]]'),
            onAction: () =>
            {
                const el = editor.selection.getNode() as HTMLDivElement;
                const id = el.getAttribute('data-shortcode');
                const name = el.getAttribute('data-name');

                if (id)
                {
                    currentEditElement = el;
                    editor.execCommand('openShortCodesModal',
                        id,
                        {
                            formId: el.getAttribute('data-form'),
                            typeId: el.getAttribute('data-type')
                        }
                    );
                }
                else if (name)
                {
                    currentEditElement = el;
                    editor.execCommand('openShortCodesModal',
                        name,
                        {
                            props: el.getAttribute('data-props')
                        }
                    );
                }

                closeAllMenus(editor);
            },
        });

        editor.ui.registry.addContextToolbar('shortcodeContextToolbar', {
            predicate: (node: Node) => node.nodeName === 'DIV' && (node as HTMLElement).hasAttribute('data-shortcode'),
            items: `${shortcodeEditName} ${shortcodeRemoveName}`,
            position: 'node',
            scope: 'node'
        });

        return {
            getMetadata: function()
            {
                return {
                    name: 'Shortcode plugin',
                    url: 'https://docs.ideo.pl/ideo_docs/ideocore/zarzadzanie/',
                };
            }
        };
    });
};

const ShortCodeSubmit = (tinymce: any, id: number, name: string, formId: number, typeId: number): string =>
{
    if (currentEditElement)
    {
        currentEditElement.setAttribute('data-shortcode', id.toString());
        currentEditElement.setAttribute('data-form', formId.toString());
        currentEditElement.setAttribute('data-type', typeId.toString());
        currentEditElement.innerHTML = `
            ${name}
        `;
    }
    else
    {
        tinymce.insertContent(`
            <div data-shortcode="${id}" data-form="${formId}" data-type="${typeId}" class="mceNonEditable">
                ${name}
            </div>
            <p></p>
        `);
    }

    return tinymce.getContent();
};

const ShortCodeRemove = (tinymce: any, id: number): string =>
{
    const shortcodeElements = tinymce.contentDocument.querySelector(`div[data-shortcode="${id}"]`);

    if (shortcodeElements)
    {
        shortcodeElements.remove();
        currentEditElement = null;
    }

    return tinymce.getContent();
};

const closeAllMenus = (editor: any): void =>
{
    const menus = document.querySelectorAll('.tox-collection--toolbar, .tox-menu, .tox-context-menu, .tox-tiered-menu, .tox-pop');

    menus.forEach(menu => (menu as HTMLElement).style.display = 'none');

    document.body.click();

    editor.selection.collapse();
};

export { ShortCodeInit, shortcodeName, shortcodeRemoveName, shortcodeEditName, ShortCodeSubmit, ShortCodeRemove };
